import SiteLayout from "@/components/feature/SiteLayout";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import HomeHero from "@/pages/home/components/HomeHero";
import HomeIntroStrip from "@/pages/home/components/HomeIntroStrip";
import HomeNewsSection from "@/pages/home/components/HomeNewsSection";
import HomeWorksSection from "@/pages/home/components/HomeWorksSection";
import HomeGallerySection from "@/pages/home/components/HomeGallerySection";
import HomeSpecialSection from "@/pages/home/components/HomeSpecialSection";
import HomeSearch from "@/pages/home/components/HomeSearch";
import HomeProfileSection from "@/pages/home/components/HomeProfileSection";

export default function Home() {
  useDocumentMeta({
    title: "张柏芝最新资讯与个人动态｜明星资料平台",
    description:
      "张柏芝明星资讯网，实时更新张柏芝的最新动态、影视作品、写真高清图片及相关新闻，为您全面呈现张柏芝的个人资料与娱乐生活。",
    keywords: "张柏芝,张柏芝资料,张柏芝动态,张柏芝影视,张柏芝新闻,娱乐明星,明星资讯",
  });

  return (
    <SiteLayout>
      <h1 className="sr-only">张柏芝最新资讯与个人动态</h1>
      <HomeHero />
      <HomeIntroStrip />
      <HomeNewsSection />
      <HomeWorksSection />
      <HomeGallerySection />
      <HomeSpecialSection />
      <HomeSearch />
      <HomeProfileSection />
    </SiteLayout>
  );
}